import { Product } from "@/modules/industry/types"

const generateWhatsAppMessage = (product: Product) => {
    const message = `Hai, apakah produk *${product.name}* masih ada ?`
    return encodeURI(message)
}

export {
    generateWhatsAppMessage
}